module.exports = "/_next/static/images/EnsureCustomerData@2x-9c14892764478f7f8bb4285086260cad.webp";